import React, { useState } from 'react'
import { useFormik } from 'formik'
import { object, string } from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { BsTriangleFill } from 'react-icons/bs'
import { auth, db } from '../firebase-config'
import { deleteDoc, doc } from 'firebase/firestore'
import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth'
import { Overlay } from '../components/Overlay'
import { Input } from '../components/Input'
import { Error } from '../components/Error'
import { Button, logOut } from '../components/Button'
import { EditEmail } from './EditEmail'
import { EditPassword } from './EditPassword'
import { EditShop } from './EditShop'
import styles from './EditProfile.module.css'

const requiredMsg = 'Dieses Feld ist verpflichtend'

const validateEditEmail = object({
  password: string().min(7, 'mindestens 7 Zeichen').required(requiredMsg),
  email: string()
    .email('muss eine gültige E-Mail sein')
    .max(255)
    .required(requiredMsg),
})

const initialValues = {
  email: '',
  password: '',
}

export const EditProfile = () => {

  const user = auth.currentUser

  const [showLogin, setLogin] = useState(true)
  const [showShop, setShop] = useState(false)
  const [overlayOpen, setOverlayOpen] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: validateEditEmail,
    onSubmit: (values) => {
      handleSubmit(values)
    },
  })

  async function handleSubmit(values) {
    const credential = EmailAuthProvider.credential(
      values.email,
      values.password,
    )

    reauthenticateWithCredential(user, credential)
      .then(() => {
        let userCurrent = auth.currentUser

        logOut(userCurrent)
          .then(() => deleteDoc(doc(db, 'users', userCurrent.uid)))
          .then(() =>
            userCurrent
              .delete()
              .then(() => {
                setOverlayOpen(false)
              })
              .catch((error) => {
                toast.error(
                  'Leider konnten wir dein Profil nicht löschen. Kontrolliere nochmal deine Eingaben und versuche es erneut.',
                  {
                    position: 'top-center',
                  },
                )
              }),
          )
      })
      .catch(() => {
        toast.error(
          'Leider konnten wir dein Profil nicht löschen. Kontrolliere nochmal deine Eingaben und versuche es erneut.',
          {
            position: 'top-center',
          },
        )
      })
  }

  return (
    <>
      <div className={styles.container}>
        <div className={styles.editForm}>
          <h2
            id="login"
            className={`${showLogin ? '' : styles.closed}`}
            onClick={() => setLogin(!showLogin) }
          >
            Login-Daten bearbeiten <BsTriangleFill />
          </h2>
          {showLogin ? <EditEmail /> : null}
          {showLogin ? <EditPassword /> : null}
        </div>

        <div className={styles.editForm}>
          <h2
            id="shop"
            className={`${showShop ? '' : styles.closed}`}
            onClick={() => setShop(!showShop) }
          >
            Shopdaten bearbeiten <BsTriangleFill />
          </h2>
          {showShop ? <EditShop /> : null}
        </div>
        <div className={styles.buttonContainer}>
          <Button
            onClick={() => {
              setOverlayOpen(true)
            }}
          >
            Profil löschen
          </Button>
          <Overlay isOpen={overlayOpen}>
            <>
              <p>
                Um all Ihre Daten endgültig löschen zu können, bitten wir sie
                aus Sicherheitsgründen, dies mit der Eingabe der E-Mail Adresse
                und des Passwortes zu bestätigen.
              </p>
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <Input
                    name='email'
                    type='email'
                    label='E-Mail'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                    required={true}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <Error msg={formik.errors.email} />
                  )}
                </div>
                <div>
                  <Input
                    name='password'
                    type='password'
                    label='Aktuelles Passwort'
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.password}
                  />
                  {formik.touched.password && formik.errors.password && (
                    <Error msg={formik.errors.password} />
                  )}
                </div>
                <div className={styles.buttonContainer}>
                  <Button type='submit'>Profil löschen</Button>
                  <Button
                    onClick={() => {
                      setOverlayOpen(false)
                    }}
                  >
                    Abbrechen
                  </Button>
                </div>
              </form>
            </>
          </Overlay>
        </div>
      </div>
    </>
  )
}
